import { useEffect, useState } from "react";
import "./fgasDocuments.scss";
import { message, Row, Card, Space, Typography, Col, Button, Flex, Form, Popconfirm, List, Divider } from "antd";
import { dateFormat, menuLinks, notifyMessages, requiredMessages } from "../../utils/constants";
import { Link as RouterLink, useParams } from "react-router-dom";
import { FilePdfOutlined, PlusOutlined, DeleteOutlined, DownloadOutlined, FolderAddOutlined, LoadingOutlined } from "@ant-design/icons";
import moment from "moment";
import * as XLSX from 'xlsx-js-style';
import * as FileSaver from "file-saver";
import TextArea from "antd/es/input/TextArea";
import { useCurrentUserContext } from "../../context/currentUserContext.js";
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { PageHeader } from "../../components/common/pageHeader.js";
import ContentLoader from "../../components/common/contentLoader.js";
import { handleAnomalyDateConvertDayJs } from "../../utils/functions.js";
import FgasDocumentsServices from "../../services/fgasDocumentServices.js";
import AddDocumentAttachment from "../documents/newDocumentAttachmentModal.js";
import ReplaceDocumentPdfModal from "../documents/replaceDocumentPdfModal.js";
import DocumentAnomaliesHistory from "../documents/documentAnmomaliesHistory.js";
import LavorazioneModal from "../documents/lavorazioneModal.js";
import { group2Rights, isSuperAdmin } from "../../configs/auth/roleRights.js";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

const { Text, Link } = Typography;
dayjs.extend(utc);
dayjs.extend(timezone);

const FgasViewDocument = () => {
  const urlParams = useParams();
  const [form] = Form.useForm();
  const { currentUser } = useCurrentUserContext();
  const anomaliesList = useSelector(state => state.anomalies.anomalies);


  const [documentData, setdocumentData] = useState(null);

  const [documentNotes, setDocumentNotes] = useState([]);
  const [loadingNotes, setLoadingNotes] = useState(false);
  const [loadingAddNote, setLoadingAddNote] = useState();
  const [loadingNoteRemove, setLoadingNoteRemove] = useState(false);


  const [documentAttachment, setDocumentAttachments] = useState("");
  const [loadingAttachmentList, setLoadingAttachmentList] = useState(false);
  const [loadingRemoveAttachment, setLoadingAttachmentDelete] = useState(false);
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);

  const [showDocumentReplacementModal, setShowDocumentReplacementModal] = useState(false);
  const [loadingReplaceDocumentPdf, setLoadingReplaceDocumentPdf] = useState(false);

  const [anomaliesHistory, setAnomaliesHistory] = useState(null);
  const [anomaliesHistoryDrawer, setAnomaliesHistoryDrawer] = useState(false);

  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingExportLogs, setLoadingExportLogs] = useState(false);
  const [showLavorazioneModal, setShowLavorazioneModal] = useState(false);
  const [loadingRegisterDocument, setLoadingRegisterDocument] = useState(false);
  const [loadingSospesoDocument, setLoadingSospesoDocument] = useState(false);



  useEffect(() => {
    getDocumentDataByID(urlParams.id, currentUser.id);
    getDocumentAttachmentList(urlParams.id);
  }, []);

  const getDocumentDataByID = async (documentId, userId) => {
    try {
      const respData = await FgasDocumentsServices.getFgasDocumentDetails(documentId, userId);
      if (respData.success) {
        let result = respData.responseObject.value.documentDetails_FGAS_DTO;
        setdocumentData(result);
        getDocumentNotesList(documentId);
        setAnomaliesHistory(result.documentAnomalyHistory);

      } else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
  };

  const handelModalClose = () => {
    setShowAttachmentModal(false);
    setShowDocumentReplacementModal(false);
    setShowLavorazioneModal(false);
  };

  const toggleUploadAttachmentModal = () => {
    setShowAttachmentModal(true);
  };

  function toggleDocumentReplacementModal() {
    setShowDocumentReplacementModal(true);
  };

  function toggleLavorazioneModal() {
    setShowLavorazioneModal(true);
  };

  const handelLavorazioneModalClose = () => {
    setShowLavorazioneModal(false);
    getDocumentDataByID(urlParams.id, currentUser.id);
  }

  //#region document options
  const onDocumentPdfView = async (documentId) => {
    message.warning(notifyMessages.generateDocumentPdfLoading);

    try {
      const respData = await FgasDocumentsServices.readDocumentPDF(documentId);

      if (respData.success) {
        let pdfData = respData.responseObject.value;
        if (pdfData.documentPdfURI) {
          // handle and convert base64 to PDF
          let base64str = pdfData.pdfArray;
          let binary = atob(base64str.replace(/\s/g, ""));
          let len = binary.length;
          let buffer = new ArrayBuffer(len);
          let view = new Uint8Array(buffer);

          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }

          // create the blob object with content-type "application/pdf"
          let blob = new Blob([view], { type: "application/pdf" });
          let url = URL.createObjectURL(blob);
          window.open(url, "Document", "width=800,height=600");
        } else {
          message.error(notifyMessages.noFileFound);
        }
      } else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
  };

  const onDocumentPdfReplace = async (file) => {
    const formData = new FormData();
    formData.append("files", file.file.file);
    formData.append("DocumentID", urlParams.id);
    formData.append("isInvoicePDF", true);
    formData.append("UserID", currentUser.id);
    formData.append("calledFromAddDocument", false);

    setLoadingReplaceDocumentPdf(true);
    try {
      const respData = await FgasDocumentsServices.addDocumentAttachment(formData);
      if (respData.success) {
        message.success(notifyMessages.addSuccess);
        setLoadingReplaceDocumentPdf(false);
        handelModalClose();
        getDocumentDataByID(urlParams.id, currentUser.id);
        getDocumentAttachmentList(urlParams.id);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingReplaceDocumentPdf(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingReplaceDocumentPdf(false);
    }
  };
  //#endregion


  //#region document notes
  const handleAddDocumentNote = async (values) => {

    values["documentID"] = urlParams.id;
    values["userID"] = currentUser.id;

    setLoadingAddNote(true);
    try {
      const respData = await FgasDocumentsServices.addDocumentNote(values);
      if (respData.success) {
        message.success(notifyMessages.operationSuccess);
        getDocumentDataByID(urlParams.id, currentUser.id);
        form.resetFields();
        setLoadingAddNote(false);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingAddNote(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingAddNote(false);
    }
  };

  const getDocumentNotesList = async (documentId) => {
    setLoadingNotes(true);
    try {
      const respData = await FgasDocumentsServices.getDocumentNotes(documentId);
      if (respData.success) {
        let result = respData.responseObject.value.documentNotes_FGAS;
        setDocumentNotes(result);
        setLoadingNotes(false);

      } else {
        setLoadingNotes(false);

      }
    } catch (error) {
      setLoadingNotes(false);

    }
  };

  const createExportLogsFile = () => {
    let formatedLogsData = [];

    if (documentNotes && documentNotes.length > 0) {
      setLoadingExportLogs(true);

      documentNotes.map(item => {
        formatedLogsData.push({
          Data: item.operationDate ? moment(item.operationDate).format(dateFormat) : "",
          Messaggio: item.description,
          Utente: item.userName ? `${item.userName}${item.roleName ? ` (${item.roleName})` : ""}` : "",
          Manutentore: item.supplierName
            ? `${item.supplierName}${item.supplierVatCode ? ` - (${item.supplierVatCode})` : ""}`
            : ""
        });
      });

      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const fileName = `ESPORTAZIONE-LOGs-${moment().format(dateFormat)}`;

      const headers = [["Data", "Messaggio", "Utente", "Manutentore"]];
      const ws = XLSX.utils.json_to_sheet([]);


      XLSX.utils.sheet_add_json(ws, formatedLogsData, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_aoa(ws, headers);


      const wb = { Sheets: { 'Logs': ws }, SheetNames: ['Logs'] };

      let wsColsWidthFormatter = [];
      for (let i = 0; i < 25; i++) {
        wsColsWidthFormatter.push({ wpx: 120 })
      }

      for (let key in ws) {
        if (typeof ws[key] !== "object") continue;
        let cell = XLSX.utils.decode_cell(key);
        if (cell.r === 1) {
          let p = key.replace("2", "1");
          ws[p].s = { font: { bold: true } };
        }
      }

      ws['!cols'] = wsColsWidthFormatter;

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
      setLoadingExportLogs(false);

      // const noteRowStart = documentNotes.length + 1;

      // // Add the "Note" label in column D, one row below the ata
      // XLSX.utils.sheet_add_aoa(ws, [["", "", "", "Note"]], { origin: `A${noteRowStart + 1}` });
      // // Add the actual note value from documentData.notes in the row below the "Note" label
      // XLSX.utils.sheet_add_aoa(ws, [["", "", "", documentData?.notes || ""]], { origin: `A${noteRowStart + 2}` });
      // // Make the "Note" label bold
      // const noteLabelCell = XLSX.utils.encode_cell({ c: 3, r: noteRowStart });
      // if (ws[noteLabelCell]) {
      //   ws[noteLabelCell].s = {
      //     font: { bold: true }
      //   };
      // }
      // // Column widths
      // ws["!cols"] = Array(25).fill({ wpx: 120 });

      // // Bold headers
      // for (let key in ws) {
      //   if (typeof ws[key] !== "object") continue;
      //   let cell = XLSX.utils.decode_cell(key);
      //   if (cell.r === 1) {
      //     let p = key.replace("2", "1");
      //     ws[p].s = { font: { bold: true } };
      //   }
      // }

      // const wb = { Sheets: { "Esportazione Fatture": ws }, SheetNames: ["Esportazione Fatture"] };
      // const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      // const dataBlob = new Blob([excelBuffer], { type: fileType });
      // FileSaver.saveAs(dataBlob, fileName + fileExtension);
      // setLoadingExportLogs(false);
    }
  };

  const onNoteRemove = async (noteId) => {
    setLoadingNoteRemove(true);
    try {
      const respData = await FgasDocumentsServices.removeDocumentNote(noteId);
      if (respData.success) {
        message.success(notifyMessages.operationSuccess);
        getDocumentNotesList(urlParams.id);
      } else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    } finally {
      setLoadingNoteRemove(false);
    }
  };
  //#endregion


  //#region document attachments
  const getDocumentAttachmentList = async (documentId) => {
    setLoadingAttachmentList(true);
    try {
      const respData = await FgasDocumentsServices.getDocumentAttachments(documentId);
      if (respData.success) {
        let result = respData.responseObject.value.attachmentList;
        setDocumentAttachments(result.filter(doc => !doc.isInvoicePDF));
        setLoadingAttachmentList(false);
      } else {
        setLoadingAttachmentList(false);
      }
    } catch (error) {
      setLoadingAttachmentList(false);
    }
  };

  const onAttachmentRemove = async (attachmentId) => {
    setLoadingAttachmentDelete(true);
    try {
      const respData = await FgasDocumentsServices.removeDocumentAtachment(attachmentId, currentUser.id);
      if (respData.success) {
        message.success(notifyMessages.operationSuccess);
        setLoadingAttachmentDelete(false);
        getDocumentAttachmentList(urlParams.id);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingAttachmentDelete(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingAttachmentDelete(false);
    }
  };

  const handelSaveAttachment = async (file) => {
    const formData = new FormData();
    formData.append("files", file.files);
    formData.append("DocumentID", urlParams.id);
    formData.append("isInvoicePDF", false);
    formData.append("UserID", currentUser.id);
    formData.append("calledFromAddDocument", false);

    console.log("formData", formData)
    setLoadingButton(true);
    try {
      const respData = await FgasDocumentsServices.addDocumentAttachment(formData);
      if (respData.success) {
        message.success(notifyMessages.addSuccess);
        setLoadingButton(false);
        handelModalClose();
        getDocumentAttachmentList(urlParams.id);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingButton(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingButton(false);
    }
  };
  //#endregion


  //#region lavorazione
  const registerDocument = async (anomalyId) => {

    const payload = {
      documentID: urlParams.id,
      userID: currentUser.id,
      anomalyID: anomalyId
    };

    setLoadingRegisterDocument(true);
    try {
      const resp = await FgasDocumentsServices.registerDocument(payload);
      if (resp.success) {
        message.success(notifyMessages.operationSuccess);
        setLoadingRegisterDocument(false);
        handelLavorazioneModalClose();
        getDocumentDataByID(urlParams.id, currentUser.id);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingRegisterDocument(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingRegisterDocument(false);
    }
  };

  const onDocumentSospeso = async (anomalyId) => {
    const payload = {
      documentID: documentData.id,
      userID: currentUser.id,
      anomalyID: anomalyId
    };

    setLoadingSospesoDocument(true);
    try {
      const respData = await FgasDocumentsServices.documentInSospeso(payload);
      if (respData.success) {
        message.success(notifyMessages.operationSuccess);
        handelLavorazioneModalClose();
      }
      else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
    finally {
      setLoadingSospesoDocument(false);
    }
  }

  const setNonDiCommpetenza = async () => {
    const payload = {
      documentID: documentData.id,
      userID: currentUser.id
    };

    try {
      const respData = await FgasDocumentsServices.handelNonCompetenzaFgas(payload);

      if (respData.success) {
        message.success(notifyMessages.success);
        handelLavorazioneModalClose();
      }
      else {
        message.error(notifyMessages.errorAccured);
      }

    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
  }
  //#endregion

  const viewCommunicationFile = async (fileUrl) => {
    message.warning(notifyMessages.generateDocumentPdfLoading)

    if (fileUrl) {
      fetch(fileUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          // Add any auth headers if needed
        }
      })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.blob();
        })
        .then(blob => {
          // Ensure it's treated as PDF
          const pdfBlob = new Blob([blob], { type: 'application/pdf' });
          const url = URL.createObjectURL(pdfBlob);
          window.open(url, "Document", "width=800,height=600");
        })
        .catch(error => {
          console.error('Error opening PDF:', error);
          message.error(notifyMessages.noFileFound);
        });
    } else {
      message.error(notifyMessages.noFileFound);
    }

  };

  return (
    <div className="document-details">
      <PageHeader title="Visualizzazione documento" />

      {!documentData && <ContentLoader />}

      {documentData && (
        <>

          {showAttachmentModal && (
            <AddDocumentAttachment
              showAttachmentModal={showAttachmentModal}
              handelModalClose={handelModalClose}
              handelSaveAttachment={handelSaveAttachment}
              loadingButton={loadingButton}
              documentData={documentData}
            />
          )}

          {showDocumentReplacementModal &&
            <ReplaceDocumentPdfModal
              showDocumentReplacementModal={showDocumentReplacementModal}
              handelModalClose={handelModalClose}
              onDocumentPdfReplace={onDocumentPdfReplace}
              documentData={documentData}
              loadingReplaceDocumentPdf={loadingReplaceDocumentPdf}
            />
          }


          {showLavorazioneModal &&
            <LavorazioneModal
              showLavorazioneModal={showLavorazioneModal}
              handelModalClose={handelLavorazioneModalClose}
              documentData={documentData}
              anomalies={anomaliesList}
              registerDocument={registerDocument}
              loadingRegisterDocument={loadingRegisterDocument}
              loadingSospesoDocument={loadingSospesoDocument}
              onDocumentSospeso={onDocumentSospeso}
              setNonCompetenza={setNonDiCommpetenza}
            />
          }

          {anomaliesHistory && (
            <DocumentAnomaliesHistory open={anomaliesHistoryDrawer} onClose={() => setAnomaliesHistoryDrawer(false)} anomalies={anomaliesHistory} />
          )}

          {/* <Card className="docDetailsCard"> */}
          <Row gutter={{ lg: 24 }}>
            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
              <div className="form-save-button-wrapper" style={{ padding: 10 }}>
                <Flex gap="small" wrap>
                  <Button type="default"> <RouterLink to={{ pathname: menuLinks.fgas }}> Lista Documenti </RouterLink> </Button>
                  {group2Rights(currentUser) && (
                    <>
                      <Button type="default"> <RouterLink to={{ pathname: `${menuLinks.fgas}/id/${urlParams.id}` }}> Modifica Documento </RouterLink> </Button>
                      <Button type="primary" onClick={() => toggleLavorazioneModal()}> Lavorazione </Button>
                    </>
                  )}
                </Flex>
              </div>
            </Col>
          </Row>

          <Row gutter={{ lg: 24 }} className="mt10">
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>

              <Row gutter={{ lg: 24 }} className="mt10">
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                  <Card size="small" className="infoCardv1" title="Dati documento" >
                    <Space direction="vertical" className="docData">
                      <span> <Text strong> Codice: </Text>  <Text>{documentData.code} </Text> </span>
                      <span> <Text strong> Data Caricamento: </Text> <Text> {documentData.dateAdded ? moment(documentData.dateAdded).format("DD/MM/YYYY") : ""}</Text> </span>
                      <span> <Text strong> Data Modifica: </Text> <Text> {documentData.lastUpdatedDate ? moment(documentData.lastUpdatedDate).format("DD/MM/YYYY") : ""}</Text> </span>
                      <span> <Text strong> Utente: </Text>  <Text>{documentData.lastEditedUserName} </Text> </span>
                      <span> <Text strong> Intervento: </Text>  <Text>{documentData.interventionTypeName} </Text> </span>
                      <span>
                        <Text strong> File Comunicazione: </Text> {documentData.fileCommunicazionePath && <Link  onClick={() => viewCommunicationFile(documentData.fileCommunicazionePath)} href={documentData.fileCommunicazionePath} download>
                          <Text style={{ width: 200, color: "#1677ff" }}
                            ellipsis={{ tooltip: documentData.fileCommunicazioneName }}>{documentData.fileCommunicazioneName}
                          </Text>
                        </Link>}
                      </span>
                      <span> <Text strong> Batch: </Text>  <Text>{documentData.flux} </Text> </span>
                      <span> <Text strong> Notes: </Text>  <Text>{documentData.notes} </Text> </span>
                    </Space>
                  </Card>
                </Col>

                <Col
                  className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} >
                  <Card size="small" className="infoCardv1" title="Stato documento">
                    <Space direction="vertical" className="docData">
                      <span> <Text strong> Stato: </Text>  <Text>{documentData.workingStatusName} </Text> </span>
                      <span> <Text strong> Operatore: </Text> <Text> {documentData.operatore} </Text> </span>
                      <span> <Text strong> PIVA / CF Operatore: </Text> <Text> {documentData.pivA_Operatore} </Text> </span>
                      <span> <Text strong> Manutentore: </Text>  <Text>{documentData.supplierName} </Text> </span>

                      <span> <Text strong> Anomalie: </Text>
                        <Text style={{ color: "#c11919", fontSize: "13px", fontWeight: 500 }}> {(anomaliesHistory && anomaliesHistory.length > 0) ? `${"• [" + handleAnomalyDateConvertDayJs(anomaliesHistory[0].operationDate) + "] "} ${anomaliesHistory[0].anomalyName}` : ""} </Text>
                        {anomaliesHistory && anomaliesHistory.length > 0 && (
                          <Text italic style={{ fontSize: 12, color: "#2485b5", marginLeft: 20 }} onClick={() => setAnomaliesHistoryDrawer(true)}> [...vedi piu] </Text>
                        )}
                      </span>
                    </Space>
                  </Card>
                </Col>
              </Row>

            </Col>
          </Row>

          <Row gutter={{ lg: 24 }} className="mt10">
            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} >
              <div className="form-save-button-wrapper" style={{ padding: 10 }}>
                <Flex gap="small" wrap>
                  <Button type="primary" onClick={() => onDocumentPdfView(documentData.id)}> Anteprima/Scarica </Button>
                  <Button type="primary" disabled={(documentNotes && documentNotes.length > 0) ? false : true} loading={loadingExportLogs} onClick={createExportLogsFile}> Esporta logs </Button>
                  {group2Rights(currentUser) && (
                    <Button type="primary" onClick={() => toggleDocumentReplacementModal()} icon={<FilePdfOutlined />}> Sostituisci PDF </Button>
                  )}
                </Flex>
              </div>
            </Col>
          </Row>

          <Row gutter={{ lg: 24 }} className="mt10">
            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} >
              <Card size="small" className="infoCardv2" title="Note" >
                <Form form={form} layout="vertical" onFinish={handleAddDocumentNote}>
                  <Form.Item
                    label={<strong>Note:</strong>}
                    name="note"
                    rules={[{ required: true, message: requiredMessages.requiredField }]}
                  >
                    <TextArea rows={4} style={{ width: "100%" }} />
                  </Form.Item>
                  <div className="notes-list">
                    <List
                      dataSource={documentNotes}
                      loading={loadingNotes}
                      renderItem={(note) => (
                        <List.Item className="notes-list-item" actions={[isSuperAdmin(currentUser) && <Button loading={loadingNoteRemove} size="small" type="ghost" icon={<DeleteOutlined />} onClick={() => onNoteRemove(note.id)} />]}>
                          <span className="notes-list-circle">○</span>
                           [ {<Text strong>{note.operationDate ? dayjs.utc(note.operationDate).tz(dayjs.tz.guess()).format("ddd D MMM YYYY HH:mm") : ""} | {note?.userName}</Text>} ] - {note.description}
                        </List.Item>
                      )}
                    />
                  </div>
                  <div className="filterButtons">
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loadingAddNote}
                      icon={<PlusOutlined />}
                    >
                      Aggiungi Note
                    </Button>
                  </div>
                </Form>
              </Card>
            </Col>
            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} >
              <Card size="small" className="infoCardv2"
                title={
                  <Space direction="horizontal">
                    <Text>Allegati a questo documento</Text>
                    <>
                      {loadingRemoveAttachment ? <LoadingOutlined /> : ""}
                      <Button
                        onClick={() => toggleUploadAttachmentModal()}
                        size="small"
                        type="primary"
                        shape="circle"
                        icon={<FolderAddOutlined />}
                      />
                    </>
                  </Space>
                }
              >
                {loadingAttachmentList ? (
                  <ContentLoader />  // Show the loader when the list is loading
                ) : (
                  <Space direction="vertical" style={{ width: "100%" }}>
                    {documentAttachment &&
                      documentAttachment.map((item, index) => (
                        <span key={item.id}>
                          <Text className="mr10" strong> {item.attachmentName} </Text>
                          <Button key={item.id + index} className="mr10" size="small" shape="circle" href={item.pathName} icon={<DownloadOutlined />} />

                          {isSuperAdmin(currentUser) && (
                            <Popconfirm
                              title={"Rimuovi questo Attachment?"}
                              onConfirm={() => onAttachmentRemove(item.id)}
                              okText={"Si"}
                              cancelText={"No"}
                            >
                              <Button key={index} size="small" shape="circle" icon={<DeleteOutlined />} />
                            </Popconfirm>
                          )}
                          <Divider style={{ margin: "10px" }} />
                        </span>
                      ))}
                  </Space>
                )}
              </Card>
            </Col>
          </Row>
          {/* </Card> */}
        </>
      )}
    </div>
  );
};

export default FgasViewDocument;
